<app-header-modal-layout
  [headerTitle]="'Save Simulation'"
  [headerColor]="'#009000'"
  [footerSubmitText]="'Save'"
  [footerCancelText]="'Cancel'"
  [footerSubmitColor]="'#009000'"
  [modalSize]="'M'"
  (close)="onClose()"
  (submit)="saveSimulation()"
>
  <form [formGroup]="form">
    <div class="row control-row">
      <div class="col-md-4 control-label-column">
        <label class="control-label">
          <span class="s7-culture" style="font-size: 20px"></span>&nbsp;Customer
        </label>
        <span *ngIf="form.get('customer')?.value?.__isNew__" class="new-tag"
          >NEW</span
        >
      </div>
      <div class="col-md-8">
        <ng-select
          [items]="filteredCustomers"
          placeholder="Select or create customer"
          bindLabel="name"
          formControlName="customer"
          [addTag]="addCustomerTag"
          addTagText="Create customer"
          notFoundText="No customers found. Write and select to create a new one."
        ></ng-select>
      </div>
      <div
        class="col-md-12 control-error"
        *ngIf="
          (form.get('customer')?.invalid && form.get('customer')?.touched) ||
          (form.get('customer')?.disabled && form.get('customer')?.touched)
        "
      >
        Customer is required
      </div>
    </div>
    <div class="row control-row">
      <div class="col-md-4 control-label-column">
        <label class="control-label">
          <span class="s7-global" style="font-size: 20px"></span>&nbsp;Region
        </label>
        <span *ngIf="form.get('region')?.value?.__isNew__" class="new-tag"
          >NEW</span
        >
      </div>
      <div class="col-md-8">
        <ng-select
          [items]="filteredRegions"
          placeholder="Select region"
          bindLabel="name"
          formControlName="region"
          notFoundText="No regions found."
          (change)="onRegionChange($event)"
        >
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-last="last"
          >
            <ng-container *ngIf="item.isRegion">
              <div
                [ngClass]="{ 'bottom-separator': index === regionsLength - 1 }"
              >
                {{ item.name }}
              </div>
            </ng-container>
            <ng-container *ngIf="item.isCountry">
              <div
                [ngClass]="{ 'top-separator': regionsLength && index === regionsLength }"
              >
                {{ item.name }}
              </div>
            </ng-container>
          </ng-template>
        </ng-select>
      </div>
      <div
        class="col-md-12 control-error"
        *ngIf="
          (form.get('region')?.invalid && form.get('region')?.touched) ||
          (form.get('region')?.disabled && form.get('region')?.touched)
        "
      >
        Region is required
      </div>
    </div>
    <div class="row control-row">
      <div class="col-md-4 control-label-column">
        <label class="control-label">
          <span class="s7-portfolio" style="font-size: 20px"></span
          >&nbsp;Project
        </label>
        <span *ngIf="form.get('project')?.value?.__isNew__" class="new-tag"
          >NEW</span
        >
      </div>
      <div class="col-md-8">
        <ng-select
          [items]="filteredProjects"
          placeholder="Select or create project"
          bindLabel="name"
          formControlName="project"
          [addTag]="addProjectTag"
          addTagText="Create project"
          notFoundText="No projects found. Write and select to create a new one."
        ></ng-select>
      </div>
      <div
        class="col-md-12 control-error"
        *ngIf="
          (form.get('project')?.invalid && form.get('project')?.touched) ||
          (form.get('project')?.disabled && form.get('project')?.touched)
        "
      >
        Project is required
      </div>
    </div>
    <div class="row control-row">
      <div class="col-md-4 control-label-column">
        <label class="control-label">
          <span class="s7-science" style="font-size: 20px"></span
          >&nbsp;Simulation
        </label>
        <span *ngIf="isNewSimulation" class="new-tag"
          >NEW</span
        >
      </div>
      <div class="col-md-8">
        <ng-select
          [items]="filteredSimulations"
          placeholder="Select or create simulation"
          bindLabel="name"
          formControlName="simulation"
          [editableSearchTerm]="true"
          [markFirst]="false"
          [addTag]="addSimulationTag"
          (search)="onSimulationNameSearch($event)"
          (blur)="commitSimulationName()"
          addTagText="Create simulation"
          notFoundText="No simulations found. Write and select to create a new one."
        ></ng-select>
      </div>
      <div
        class="col-md-12 control-error"
        *ngIf="
          (form.get('simulation')?.invalid &&
            form.get('simulation')?.touched) ||
          (form.get('simulation')?.disabled && form.get('simulation')?.touched)
        "
      >
        {{ form.get('simulation')?.hasError('duplicateName')
          ? 'A simulation with this name already exists in this project. Select it from the list or use another name.'
          : 'Simulation is required' }}
      </div>
    </div>
    <div class="row control-row">
      <div class="col-md-4">
        <label class="control-label">
          <span class="s7-look" style="font-size: 20px"></span>&nbsp;Visibility
        </label>
      </div>
      <div class="col-md-8">
        <ng-select
          [items]="visibilityOptions"
          bindLabel="description"
          formControlName="visibility"
          placeholder="Select visibility"
          [searchable]="false"
        ></ng-select>
      </div>
      <div
        class="col-md-12 control-error"
        *ngIf="
          (form.get('visibility')?.invalid &&
            form.get('visibility')?.touched) ||
          (form.get('visibility')?.disabled && form.get('visibility')?.touched)
        "
      >
        Visibility is required
      </div>
    </div>
    <div class="row control-row">
      <div class="col-md-12">
        <label class="control-label">Notes</label>
        <textarea
          class="form-control notes-textarea"
          formControlName="notes"
          rows="3"
          placeholder="Enter notes (Optional)"
        ></textarea>
      </div>
    </div>
  </form>
</app-header-modal-layout>
